/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:768px){a[href^=\"tel:\"]{pointer-events:none;text-decoration:none!important}.about-image{max-width:400px}}@media (max-width:767px){.about-image{max-width:inherit}}@media (max-width:500px){.about-image{max-width:500px}}.about-info .about-info-subtitle a{color:#565656;font-family:Roboto;font-size:12px;font-weight:400;line-height:16px;text-align:center;letter-spacing:.5px;text-decoration:underline}.about-image{float:left;margin-right:20px;margin-bottom:20px;width:100%}.aboutClose.close{font-size:54px}"];
export { styles as styles };
